import { render, staticRenderFns } from "./surgicalKitAction.vue?vue&type=template&id=6b92e5c5&scoped=true"
import script from "./surgicalKitAction.vue?vue&type=script&lang=js"
export * from "./surgicalKitAction.vue?vue&type=script&lang=js"
import style0 from "./surgicalKitAction.vue?vue&type=style&index=0&id=6b92e5c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b92e5c5",
  null
  
)

export default component.exports